import { FEATURE_FLAGS } from './constants';

export const defaultFlags = {};
